import { useContext } from 'react'
import AuthorizationContext from './AuthorizationProvider.context'

/**
 * The authorization custom hook.
 */
export const useAuthorization = () => {
  const { isPublic, isPrivated, userType, orgCode } = useContext(AuthorizationContext)

  return { isPublic, isPrivated, userType, orgCode }
}
